function caracteristicaModel(data) {
  this.text = data.attributes?.texto
  this.link = data.attributes?.url;
}
export default caracteristicaModel;
